export default class Login{
    constructor($scope,
                $routeParams,
                $location,
                toastr,
                loginService,
                $rootScope,
                info            
                ){
        this.scope    = $scope;
        this.location = $location;
        this.toastr = toastr;
        this.loginService = loginService;
        this.rootScope = $rootScope;
        this.info = info;
        this.routeParams = $routeParams;        
        if ($rootScope.isLogged) {
            this.location.path('/panel');
        }        
    }

    signin(user) {
        this.loginService.login(user).then((res, error) => {
            if (error){       
                this.toastr.error('Error', 'Usuario o contraseña no son correctos', {
                    timeOut: 2000,
                    closeButton: true
                });
            } else {
                if (res.data.success) {
                    if(res.data.message.proyectos.length > 0){
                        localStorage.setItem('cliente', res.data.message.proyectos[0].cliente.abreviacion)
                    }
                    localStorage.setItem('token', res.data.message.token);
                    localStorage.setItem('IdUser', res.data.message.Id);
                    this.info.set('Id', res.data.message.id);
                    this.info.set('nombre', res.data.message.nombre);
                    this.info.set('apellido', res.data.message.apellido);
                    this.info.set('permisos', res.data.message.permisos); 
                    this.info.set('flag_tecnico', res.data.message.flag_tecnico);
                    this.info.set('proyectos', res.data.message.proyectos);                    
                    localStorage.setItem('flag_tecnico', res.data.message.flag_tecnico);
                    if (this.routeParams.next) {                        
                        this.rootScope.redirected = false;
                        let url = this.routeParams.next;
                        if (this.routeParams.detail) {                            
                            url = this.routeParams.next + '/' +this.routeParams.detail; 
                        } 
                        this.location.path(url);
                    } else {
                        this.location.path('/panel');
                    }                                                               
                } else {
                   this.toastr.error('Error', res.data.message, {
                        timeOut: 2000,
                        closeButton: true
                    }); 
                }
            }
        })
        .catch((e) => {
            console.log(e)
            this.toastr.error('Error', e.data.message, {
                timeOut: 2000,
                closeButton: true
            });
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/login/login.js